export const KPICard = ({ label, value, sublabel, icon: Icon, accent = "primary", testid }) => {
  const accents = {
    primary: "text-[#C57B67]",
    success: "text-[#8A9A86]",
    warning: "text-[#E3A569]",
    danger: "text-[#B85C5C]",
    neutral: "text-[#2D2A26]",
  };
  return (
    <div
      className="bg-white border border-[#E5E0D8] rounded-xl p-5 transition-all duration-200 hover:border-[#D5CFC5] hover:shadow-sm"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-semibold tracking-widest uppercase text-[#736F68] font-display">
          {label}
        </p>
        {Icon && <Icon size={18} className={accents[accent]} weight="duotone" />}
      </div>
      <p className="mt-3 text-3xl font-semibold text-[#2D2A26] font-display tracking-tight">
        {value}
      </p>
      {sublabel && <p className="mt-1 text-xs text-[#736F68]">{sublabel}</p>}
    </div>
  );
};